<ng-container *ngIf="(surveyViewerService.activeSurvey$ | async).form.get(question.key)">
  <div data-testId="nameForm" class="name-flex-container">

      <mat-form-field *ngIf="questionFormControl.get(question.firstNameControlName)" [hideRequiredMarker]="true"
                      data-testId="first_name" class="mr-4">
          <mat-label>{{question.statements[question.firstNameControlName].label | translateLabel: activeLang}}</mat-label>
          <input appNoPaste matInput placeholder="John"
                 [formControl]="$any(questionFormControl.get(question.firstNameControlName))"
                 (blur)="questionFormControl.get(question.firstNameControlName).setValue($event.target.value.trim())">
          <mat-error>
            {{'Champ obligatoire'|transloco}}.
          </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="questionFormControl.get(question.lastNameControlName)" [hideRequiredMarker]="true"
                      data-testId="last_name">
          <mat-label>{{question.statements[question.lastNameControlName].label | translateLabel: activeLang}}</mat-label>
          <input appNoPaste matInput placeholder="Doe"
                 [formControl]="$any(questionFormControl.get(question.lastNameControlName))"
                 (blur)="questionFormControl.get(question.lastNameControlName).setValue($event.target.value.trim())">
        <mat-error>
          {{'Champ obligatoire'|transloco}}.
        </mat-error>
      </mat-form-field>
  </div>
</ng-container>
